import React from "react";

import { redirectionWrapper } from "../../../util/commonFunctions";
import ErrorPage from "../../../components/shared/ErrorPage";

const SpeakersHorizontalWideCard = (props) => {
    return (
        <div className="companies-tab-content">
            {props.experts.length == 0 &&
                <ErrorPage
                    imageUrl="/assets/svg/tier-empty-state.svg"
                    errorPageHeading="This event has no speakers yet."
                    errorPageDescription="Add an Expert to your Watchlist to get started."
                    paraUrl=""
                    paraUrlText=""
                    class="tier"
                />
            }
            {props.experts.length > 0 && props.experts.map((item, index) => {
                const speakertHasCompany = item.companyName && Object.keys(item.companyName).length > 0;
                const speakerName = item.firstName + " " + item.lastName;
                return (
                    <div className="companies-tab-item" key={`expert-card-${index}`}>
                        <div className="row align-items-center">
                            <div className="col-9 col-md-9">
                                <div className="companies-info">
                                    <div className="companies-logo expert-circle">
                                        <a
                                            href={`/expert/${speakerName}/${item.id}`}
                                            onClick={event => {
                                                redirectionWrapper(
                                                    'expert',
                                                    event,
                                                    item.id,
                                                    speakerName,
                                                    props.parentProps,
                                                    props.parentProps.showLoader,
                                                    props.parentProps.hideLoader
                                                )
                                            }
                                            }
                                        >
                                            <img src={item.photo} style={{ maxWidth: "100%" }} />
                                        </a>
                                    </div>
                                    <div className="companies-title">
                                        <h3
                                            onClick={event => {
                                                redirectionWrapper(
                                                    'expert',
                                                    event,
                                                    item.id,
                                                    speakerName,
                                                    props.parentProps,
                                                    props.parentProps.showLoader,
                                                    props.parentProps.hideLoader
                                                )
                                            }
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            {speakerName}
                                        </h3>
                                        <em>{item.expertRoles}
                                        {speakertHasCompany && (
                                            item && item.companyProfile ?
                                                <span
                                                    onClick={event => {
                                                        if (item.companyProfile) {
                                                            redirectionWrapper(
                                                                'company',
                                                                event,
                                                                item.companyId,
                                                                item.companyName,
                                                                props.parentProps,
                                                                props.parentProps.showLoader,
                                                                props.parentProps.hideLoader
                                                            )
                                                        }
                                                    }}
                                                >                                                    
                                                    {item && item.companyName}
                                                </span>
                                                :
                                                <span style={{ cursor: "auto" }} className="light-blue">
                                                    {item && item.companyName}
                                                </span>
                                        )}
                                           
                                        </em>

                                        <ul className="expert-social">
                                            {item && item.linkedInURL && <li><a href={item?.linkedinUrl} target="_blank" className="linkedin"></a></li>}
                                            {item && item.twitterURL && <li><a href={`https://www.${item?.twitter}`} target="_blank" className="twitter"></a></li>}
                                        </ul>
                                        {item.expertiseList && item.expertiseList.length > 0 &&
                                            <div className="companies-info-footer">
                                                <ul>
                                                    {item.expertiseList.map((expertise, expertiseIndex) => {
                                                        return (
                                                            <li
                                                                onClick={event => {
                                                                    redirectionWrapper(
                                                                        'topic',
                                                                        event,
                                                                        expertise.id,
                                                                        expertise.name,
                                                                        props.parentProps,
                                                                        props.parentProps.showLoader,
                                                                        props.parentProps.hideLoader,
                                                                        props.parentProps.currentLanguage
                                                                    )
                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                                key={`expertise-${expertiseIndex}`}
                                                            >
                                                                {expertise.name}
                                                            </li>
                                                        );
                                                    })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 col-md-3">
                                <div className="companies-follow-btns">
                                    <span className={!item.isFollowing ? "nofollow-btn" : "nofollow-btn hide"} onClick={() => props.followObject(item.id, "expert")} >Follow</span>
                                    {props.unFollowObject &&
                                        <span className={item.isFollowing ? "follow-btn gray-follow-btn" : "follow-btn hide"} onClick={() => props.unFollowObject(item.id, "expert")} >Following</span>
                                    }
                                    {!props.unFollowObject &&
                                        <span className={item.isFollowing ? "follow-btn gray-follow-btn disable-unfollow" : "follow-btn hide"} >Following</span>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                );
            })
            }
        </div>
    );
};

export default SpeakersHorizontalWideCard;